module.exports = __webpack_public_path__ + "media/src/images/icons/topics-e2e88b86af1ab306963e36ec1123ffcb.svg";